import { Box, PDF_FONT_SIZE } from '@/components';
import type { CSSProperties, FC } from 'react';

type Props = {
  text: string | number;
  textStyle?: CSSProperties;
  textWrapperStyle?: CSSProperties;
  width?: string | number;
  align?: 'left' | 'center' | 'right';
  paddingHorizontal?: 'small' | 'medium';
};

const paddingHorizontalMap = {
  small: 1,
  medium: 2,
};

export const TextCell: FC<Props> = ({
  text,
  textStyle,
  textWrapperStyle,
  width,
  align,
  paddingHorizontal,
}) => {
  return (
    // NOTE: height: 100%を付けると印刷時にページ全体に引き伸ばされるので注意
    <Box width={width} display="flex" alignItems="center" {...textWrapperStyle}>
      <p
        style={{
          width: '100%',
          margin: 0,
          padding: `4px ${paddingHorizontalMap[paddingHorizontal ?? 'medium']}px`,
          lineHeight: 1.25,
          fontSize: PDF_FONT_SIZE.MD,
          wordBreak: 'break-all',
          overflowWrap: 'anywhere',
          whiteSpace: 'pre-wrap',
          textAlign: align ?? 'left',
          fontFamily: 'Noto Sans JP',
          ...textStyle,
        }}
      >
        {text}
      </p>
    </Box>
  );
};
